import { RootState } from "@/store"
import { PayloadAction, createSlice } from "@reduxjs/toolkit"

// 鼠标坐标
interface MousePos {
  x: number
  y: number
}

interface State {
  // 鼠标在云桌面窗口中的坐标
  pos: MousePos | null
  // 系统鼠标指针样式（CSS cursor 值）
  sysCursor?: string | undefined
}
const initialState: State = { pos: null }

const MousePosSlice = createSlice({
  name: "mousePos",
  initialState,
  reducers: {
    // 更新鼠标位置
    updateMousePos: (state, action: PayloadAction<MousePos | null>) => {
      const pos = action.payload
      state.pos = pos
      if (pos === null) {
        // 鼠标移出云桌面时,显示系统鼠标
        state.sysCursor = undefined
      } else {
        // 鼠标在云桌面内时,隐藏系统鼠标
        state.sysCursor = "none"
      }
    },
    // 设置自定义光标样式（CSS cursor 值） ，非全屏模式下使用
    setCustomCursor: (state, action: PayloadAction<string | undefined>) => {
      state.sysCursor = action.payload
    },
  },
})

export const { updateMousePos, setCustomCursor } = MousePosSlice.actions

export const selectMousePos = (state: RootState) => state.mousePos.pos
export const selectCursorStyle = (state: RootState) => state.mousePos.sysCursor

export default MousePosSlice.reducer
